import DomContent from "../../dom/index";
import Experience from "../../experience/Experience";
import Analytics from "../utils/Analytics";
import { cookiesInit } from "../utils/cookiesIntegration";
import { setupStorageAccess } from "../utils/localStorage";

const introductionPage = document.querySelector(".introduction");
const heading = introductionPage?.querySelector(".introduction__body--heading");
const subheading = introductionPage?.querySelector(
  ".introduction__body--subheading",
);
const permissionsPage = <HTMLDivElement>document?.querySelector(".permissions");

const permissionsBackButton = document?.querySelector(
  "#permissions_back-Button",
);

const introductionInfo = document.querySelector<HTMLDivElement>(
  ".introduction__body_information",
);
const introductionTCs = document.querySelector<HTMLDivElement>(
  ".introduction__body_terms",
);
const introductionBtnsContainer = document.querySelector(
  ".introduction__button-container",
);

const continueButton = introductionPage?.querySelector("#continue-button");
const permissionsContinueButton = document?.querySelector(
  "#permissions__continue-button",
);

const splashScreen = document.querySelector("#splash_screen");

const mainUI = document.querySelector(".ui");

const tcsAccept = document.querySelector(
  ".introduction_terms__buttons .button.accept",
);
const tcsReject = document.querySelector(
  ".introduction_terms__buttons .button.reject",
);
const tcsNext = document.querySelector(
  ".introduction__body_terms .button.next",
);
const tcsWarning = document.querySelector(
  ".introduction_terms__buttons > .warning",
);

const setupTCsScreen = (accept: () => void) => {
  const scrollContainer = introductionBtnsContainer!
    .parentElement! as HTMLDivElement;
  scrollContainer.classList.add("overflow-scroll");
  let scrollAmount = scrollContainer.getBoundingClientRect().height * 0.9;

  let currentOffset = 0;
  let isScrolling = false;
  let warningOn = false;

  scrollContainer.addEventListener("scroll", () => {
    isScrolling = false;
  });

  tcsNext?.addEventListener("click", () => {
    if (isScrolling) return;
    isScrolling = true;

    currentOffset += scrollAmount;
    scrollContainer.scrollTo({
      top: currentOffset,
      behavior: "smooth",
    });
  });

  tcsReject?.addEventListener("click", () => {
    if (warningOn) window.location.reload();
    else {
      warningOn = true;
      tcsWarning?.classList.remove("hidden");
    }
  });
  tcsAccept?.addEventListener("click", () => {
    scrollContainer.classList.remove("overflow-scroll");
    accept();
  });
};

export default function Introduction() {
  let experience = new Experience();

  /* Functions */

  mainUI?.classList.add("hidden");
  document.body.style.padding = "var(--sat) var(--sar) var(--sab) var(--sal)";

  const storage = cookiesInit();
  const { readTCsConsentFromStorage, writeTCsConsentToStorage } =
    setupStorageAccess(storage);

  if (readTCsConsentFromStorage()) navigateToPage(3);
  else
    setupTCsScreen(() => {
      writeTCsConsentToStorage(true);
      navigateToPage(3);
    });

  setTimeout(() => {
    if (!splashScreen) return;
    splashScreen?.classList.add("hidden");
    splashScreen?.setAttribute("aria-hidden", "true");
  }, 500);

  function navigateToPage(pageIndex: number) {
    if (!heading || !subheading || !continueButton || !permissionsPage) return;

    switch (pageIndex) {
      case 0:
        introductionPage?.classList.remove("hidden");
        permissionsPage?.classList.add("hidden");
        break;

      case 1:
        introductionPage?.classList.add("hidden");
        permissionsPage.style.display = "flex";
        break;

      case 2:
        permissionsPage?.classList.add("hidden");
        document.body.removeAttribute("style");
        mainUI?.classList.remove("hidden");
        DomContent();
        experience.startScene();
        break;
      case 3:
        introductionInfo?.classList.remove("hidden");
        introductionBtnsContainer?.classList.remove("hidden");
        introductionTCs?.classList.add("hidden");
    }
  }

  continueButton?.addEventListener("click", () => {
    navigateToPage(1);
  });

  permissionsBackButton?.addEventListener("click", () => {
    navigateToPage(0);
  });

  permissionsContinueButton?.addEventListener("click", () => {
    experience.getPermissions().then(Analytics.allowCameraAccess);

    permissionsPage.style.display = "none";
    navigateToPage(2);
  });
}
